import type { DailyStatsRequest, DailyStatsRow } from "@adlywise/shared";
import type { ChoiceOption } from "@/features/analytics/components/filters/types";

export type AnalyticsDateRange = {
  startDate: Date;
  endDate: Date;
};

export type AnalyticsPreset = "today" | "last7Days";

export type AnalyticsDailyStatsRequest = DailyStatsRequest;
export type AnalyticsDailyStatsRow = DailyStatsRow;

export type AnalyticsFilters = {
  country: string[];
  region: ChoiceOption<number>[];
  city: ChoiceOption<number>[];
  platform: ChoiceOption<number>[];
  deviceType: number[];
  channelId: number[];
  campaignUuid: string[];
  kind: number[];
  categories: string[];
  tags: string[];
};

export type AnalyticsCampaignOption = {
  uuid: string;
  name: string;
};

export type AnalyticsChannelOption = {
  id: number;
  name: string;
  kind: "static" | "dynamic" | "overlay" | "banner";
  type: "free" | "paid";
};

export type AnalyticsCategoryOption = {
  id: string;
  name: string;
};

export const EMPTY_ANALYTICS_FILTERS: AnalyticsFilters = {
  country: [],
  region: [],
  city: [],
  platform: [],
  deviceType: [],
  channelId: [],
  campaignUuid: [],
  kind: [],
  categories: [],
  tags: [],
};
